import TableModule from "@/components/TableModule";
import useFilterData from "@/hooks/useFIlterData";

export default function TablePreviewModule({ data }) {
	const tableModulesData = data?.tableModules || []
	const contextData = useFilterData(tableModulesData)

	return contextData ? <TableModule data={contextData} /> : null
}